<template>
  <v-flex xs12 sm6 md4>
    <router-link
      :to="{ name: 'categories', params: { category: value.pageName } }"
    >
      <v-card height="250" color="grey lighten-1" dark>
        <v-img
          :src="require(`@/assets/categories/${value.pageName}/${value.image}`)"
          height="100%"
        >
          <v-layout fill-height text-right wrap ma-0>
            <v-flex xs12>
              <v-chip
                label
                class="mx-0 mb-2 text-uppercase"
                color="grey darken-3"
                text-color="white"
              >
                {{ value.title }}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-img>
      </v-card>
    </router-link>
  </v-flex>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style>
.v-image__image {
  transition: 0.3s linear;
}
</style>
